import React from 'react';
import { Stack } from '@mui/material';
import { CheckboxField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { capitalizeFirstLetter } from 'formatters';

import { VOFilters, VOFilterType } from '../../types';
import { initialVOFiltersValue } from '../../constants';

export const DisplayType = () => {
  const { control } = useFormContext<VOFilters>();

  return (
    <Stack gap="0.5rem">
      {Object.keys(initialVOFiltersValue[VOFilterType.DISPLAY]).map(type => (
        <CheckboxField
          key={type}
          control={control}
          label={capitalizeFirstLetter(type)}
          name={`DISPLAY.${type as keyof VOFilters['DISPLAY']}`}
        />
      ))}
    </Stack>
  );
};
